import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import Modal from "@mui/material/Modal";
import { Box, Select, MenuItem } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Main from "../Main";
import { Button } from "@mui/material";
import AppBreadcrumbs from "../../components/ui/AppBreadcrumbs";
import { CloseOutlined } from "@mui/icons-material";
// import { showToastMessage } from "../../utils/toastUtils"; // ❌ Removed
import { FinalMerchantActive, getSingleMerchant, KycMerchant } from "../../api/userAuth";
import KycUploadModal from "./KycUploadModal";

// ✅ Added Notification Context
import { useNotify } from "../../context/NotifyContext";
import { getPincodeDetails } from "../../utils/pincodeLookup";

const RegistrationForm = () => {
  const {notify} = useNotify(); // ✅ Use this instead of showToastMessage

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    gender: "",
    dob: "",
    address: "",
    city: "",
    state: "",
    district: "",
    pin: "",
    fatherName: "",
    motherName: "",
    occupation: "",
  });

  const [kycFiles, setKycFiles] = useState(null);
  const [uploadOpen, setUploadOpen] = useState(false);
const [isKycUploaded, setIsKycUploaded] = useState(false);
  const { username } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({
    plan: "",
    username: "",
    role: "",
  });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   // ✅ Proper Validation
  //   if (name === "aadhaar" || name === "pin") {
  //     if (!/^\d*$/.test(value)) return; // only digits
  //   }
  //   if (name === "dob") {
  //     const today = new Date().toISOString().split("T")[0];
  //     if (value > today) return;
  //   }

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

const handleChange = async (e) => {
  const { name, value } = e.target;

  if (name === "aadhaar" || name === "pin") {
    if (!/^\d*$/.test(value)) return;
  }

  if (name === "dob") {
    const today = new Date().toISOString().split("T")[0];
    if (value > today) return;
  }

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  // Pincode lookup
  if (name === "pin" && value.length === 6) {
    try {
      const location = await getPincodeDetails(value);

      if (!location) {
        notify("Invalid or unavailable pincode", "error");

        setFormData((prev) => ({
          ...prev,
          city: "",
          district: "",
          state: "",
        }));

        return;
      }

      setFormData((prev) => ({
        ...prev,
        city: location.city,
        district: location.district,
        state: location.state,
      }));
    } catch (error) {
      notify("Unable to fetch pincode details", "error");
    }
  }
};

  const submitKYC = async () => {
    // ✅ DOB validation
    const dobDate = new Date(formData.dob);
    if (!formData.dob || isNaN(dobDate.getTime())) {
      return notify("Please enter a valid Date of Birth", "error");
    }
    if (dobDate > new Date()) {
      return notify("Date of Birth cannot be in the future", "error");
    }

    // ✅ KYC validation
    // if (
    //   !kycFiles ||
    //   (!kycFiles.aadhaarFront && !kycFiles.aadhaarFrontUrl) ||
    //   (!kycFiles.aadhaarBack && !kycFiles.aadhaarBackUrl) ||
    //   (!kycFiles.panFile && !kycFiles.panFileUrl)
    // ) {
    //   return notify("Please upload all KYC documents", "error");
    // }

    // ❌ Only validate if NOT already uploaded
if (!isKycUploaded) {
  if (
    !kycFiles ||
    !kycFiles.aadhaarFront ||
    !kycFiles.aadhaarBack ||
    !kycFiles.panFile
  ) {
    return notify("Please upload all KYC documents", "error");
  }
}

    setLoading(true);

    try {
      const payload = new FormData();
      Object.keys(formData).forEach((key) => payload.append(key, formData[key]));

      payload.append("aadhaarFront", kycFiles.aadhaarFront);
      payload.append("aadhaarBack", kycFiles.aadhaarBack);
      payload.append("panFile", kycFiles.panFile);
      payload.append("aadhaar", kycFiles.aadhaar);
      payload.append("pan", kycFiles.pan);

      const res = await KycMerchant(username, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.success) {
        notify(res.message || "KYC Submitted!", "success");

        const data = res.data;
        setModalData({
          plan: data.plan,
          username: data.user?.userName,
          role: data.user?.role,
        });
        setModalOpen(true);
      } else {
        notify(res.message || "Submission Failed", "error");
      }
    } catch (err) {
      notify(err?.response?.data?.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!username) {
      notify("Username not found", "error");
      navigate("/dashboard");
      return;
    }

    let isMounted = true;

    const fetchMerchant = async () => {
      try {
        setLoading(true);

        const res = await getSingleMerchant(username);

        if (!res?.success) {
          notify(res?.message || "Failed to fetch merchant", "error");
          return;
        }

        if (!isMounted) return;

        const user = res.data?.user;

        setKycFiles({
          aadhaar: user?.aadhaar || "",
          pan: user?.pan || "",
          aadhaarFront: null,
          aadhaarBack: null,
          panFile: null,
          aadhaarFrontUrl: user?.aadhaarFrontUrl || "",
          aadhaarBackUrl: user?.aadhaarBackUrl || "",
          panFileUrl: user?.panFileUrl || "",
        });


        if (
  user?.aadhaarFrontUrl &&
  user?.aadhaarBackUrl &&
  user?.panFileUrl
) {
  setIsKycUploaded(true);
}

        const formattedDob = user?.dob
          ? new Date(user.dob).toISOString().split("T")[0]
          : "";

        setFormData({
          fullName: user?.fullName || "",
          fatherName: user?.fatherName || "",
          motherName: user?.motherName || "",
          gender: user?.gender || "",
          email: user?.email || "",
          address: user?.address || "",
          dob: formattedDob,
          city: user?.city || "",
          state: user?.state || "",
          district: user?.district || "",
          pin: user?.pin || "",
          occupation: user?.occupation || "",
        });

        if (user?.status === "PENDING") {
          notify("KYC already submitted & under review", "info");
        }
      } catch (error) {
        if (isMounted) {
          notify(error?.response?.data?.message || "Something went wrong", "error");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchMerchant();

    return () => {
      isMounted = false;
    };
  }, [username]);

  const GoUploadStoreAddress = async () => {
    if (!modalData.plan || !username) {
      return notify("Plan is not active", "error");
    }

    setLoading(true);
    try {
      const payload = { planId: modalData?.plan?._id, userName: username, active: true };
      const res = await FinalMerchantActive(username, payload);

      if (res.success) {
        notify(res?.message || "User Created & Activated!", "success");
        navigate(`/merchant-store-details/${username}`);
        setModalOpen(false);
      }
    } catch (err) {
      notify(err?.response?.data?.message || "User Creation Failed", "error");
    } finally {
      setLoading(false);
    }
  };




  
  return (
    <Main showRightPanel={false}>
      <div className="flex flex-col items-start w-full">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Registration" },
            { label: "Agent Registration" },
            { label: "Agent Personal Details" },
          ]}
        />
        <div className="border border-gray-100 shadow-md rounded-lg p-6 w-full mt-4">
          <h2 className="text-xl font-semibold mb-6">Agent Personal Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block  font-semibold mb-1 text-sm">Full Name 
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
            </div>
            <div>
              <label className="block  font-semibold mb-1 text-sm">Occupation 
                <span className="text-red-500">*</span>
              </label>
               <Box
  sx={{
    flexBasis: { xs: "100%", md: "50%" },
  }}
>
  <Select
    name="occupation"
    value={formData.occupation}
    onChange={handleChange}
    displayEmpty
    sx={{
      width: "100%",
      fontSize: "0.975rem",
      borderRadius: "7px",
      border: "1px solid #D1D5DB",
      "& .MuiSelect-select": {
        paddingTop: { xs: "8px", md: "10px" },
        paddingBottom: { xs: "8px", md: "10px" },
        paddingLeft: "12px",
        minHeight: { xs: 40, md: 44 },
        display: "flex",
        alignItems: "center",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "& .MuiSelect-icon": {
        fontSize: { xs: "1.25rem", md: "1rem" },
      },
    }}
  >
    <MenuItem value="">
      Select
    </MenuItem>
    <MenuItem value="Engineer">Engineer</MenuItem>
    <MenuItem value="Teacher">Teacher</MenuItem>
    <MenuItem value="Business">Business</MenuItem>
  </Select>
</Box>
            </div>
            <div>
              <label className="block  font-semibold mb-1 text-sm">Father's / Guardian Name 
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="fatherName"
                value={formData.fatherName}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
            </div>
            <div>
              <label className="block  font-semibold mb-1 text-sm">Mother's Name 
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="motherName"
                value={formData.motherName}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
            </div>
            <div>
              <label className="block  font-semibold mb-1 text-sm">Gender 
                <span className="text-red-500">*</span>
              </label>
             <Box
           sx={{
           flexBasis: { xs: "100%", md: "50%" },
           }}>
          <Select
           name="gender"
           value={formData.gender}
           onChange={handleChange}
           displayEmpty
          sx={{
          width: "100%",
          fontSize: "0.975rem",
          borderRadius: "7px",
          border: "1px solid #D1D5DB",
          "& .MuiSelect-select": {
          paddingTop: { xs: "8px", md: "10px" },
          paddingBottom: { xs: "8px", md: "10px" },
          paddingLeft: "12px",
          minHeight: { xs: 40, md: 44 },
          display: "flex",
          alignItems: "center",
         },
        "& .MuiOutlinedInput-notchedOutline": {
         border: "none",
        },
        "& .MuiSelect-icon": {
        fontSize: { xs: "1.25rem", md: "1rem" },
       },
      }}
      >
     <MenuItem value="">Select</MenuItem>
     <MenuItem value="male">Male</MenuItem>
     <MenuItem value="female">Female</MenuItem>
     <MenuItem value="Other">Other</MenuItem>
    </Select>
   </Box>
            </div>
         <div className="w-full">
  <label className="block  font-semibold mb-1 text-sm">
    Date of Birth <span className="text-red-500">*</span>
  </label>
  <input
    type="date"
    name="dob"
    value={formData.dob}
    onChange={handleChange}
    max={new Date().toISOString().split("T")[0]} // 🚫 future disabled
    className="
      w-full
      border
      p-2
      
      rounded-md
      text-sm
      focus:outline-none
      focus:ring-2
      focus:ring-[#02026E]
    "
  />
</div>
      
            <div>
              <label className="block  font-semibold mb-1 text-sm">Pin Code 
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="pin"
                value={formData.pin}
                onChange={handleChange}
                maxLength={6}
                className="w-full border p-2 rounded"
              />
            </div>
            <div>
              <label className="block  font-semibold mb-1 text-sm">City / Area 
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
            </div>
            <div>
              <label className="block  font-semibold mb-1 text-sm">District 
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="district"
                value={formData.district}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
            </div>
            <div>
              <label className="block  font-semibold mb-1 text-sm">State 
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block   font-semibold mb-1 text-sm">Complete Address 
                <span className="text-red-500">*</span>
              </label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full border p-2 rounded"/>
            </div>
          </div>
          <div className="flex justify-between flex-wrap mt-6 gap-2">

<div>
  <Button onClick={() => setUploadOpen(true)}>
  Upload KYC
</Button>

{/* {kycFiles && (
  <p className="text-green-600 text-sm">
    ✔ Documents uploaded successfully
  </p>
)} */}

{isKycUploaded ? (
  <p className="text-green-600 text-sm font-semibold">
    ✔ KYC Already Uploaded (Verified)
  </p>
) : kycFiles ? (
  <p className="text-green-600 text-sm">
    ✔ Documents uploaded successfully
  </p>
) : null}

<KycUploadModal
  open={uploadOpen}
  onClose={() => setUploadOpen(false)}
  onSubmit={(data) => setKycFiles(data)}
  initialData={kycFiles}
/>


</div>

            {/* <Button onClick={() => setUploadOpen(true)}>Upload KYC</Button> */}
          <button
         onClick={submitKYC}
                  type="submit"
                  disabled={loading}
className="ds-btn ds-btn-primary">
              {loading ? "Processing..." : "Proceed"}
        </button>
          </div>
        </div>
      </div>
     <div className="px-2">
          <Modal open={modalOpen} onClose={() => setModalOpen(false)} className="px-2" sx={{
            padding:'20px'
          }}>
         <Box className="bg-white dark:bg-slate-800 text-black dark:text-white"
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "calc(100% - 20px)", // 👈 10px left + 10px right
      maxWidth: 420,
      borderRadius: "8px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
      p: 2,
      outline: "none",
      border: "none",
    }}
  >
    {}
      <div className="flex items-center justify-between gap-1">
            <h2 className="text-lg font-semibold mb-4 px-2 ">Confirm User Details</h2>
          <h2 onClick={()=>setModalOpen(false)} className="text-lg font-semibold mb-4"><CloseOutlined /> </h2>
      </div>
          <label className="font-semibold">Plan:</label>
          <input
            disabled
            className="border w-full p-2 my-2"
            value={modalData.plan?.code}
          />
          <label className="font-semibold">Username:</label>
          <input
            disabled
            className="border w-full p-2 my-2"
            value={modalData.username}
          />
          <label className="font-semibold">Role:</label>
          <input
            disabled
            className="border w-full p-2 my-2"
            value={modalData.role}
          />
          {}
<button
  type="button"
  onClick={GoUploadStoreAddress}
  disabled={loading}
  className="ds-btn ds-btn-primary ds-btn-block mt-4"
>
  {loading ? "Processing..." : "Proceed Next"}
</button>


        </Box>
      </Modal>

     </div>

    </Main>
  );
};
export default RegistrationForm;